<template>
    <div>
        <div class="mini-card">
            <el-card>
                <el-row :gutter="20">
                    <el-col :span="6">
                        <h2>{{ productionZone.name }}</h2>
                        <!-- <div class="info-identity">
                            <p><span>{{ $t('total_time_count')}}: </span><span class="data-display">127 h</span></p>
                            <p><span>{{ $t('status') }}: </span><span class="data-display">Contrôle en cours</span></p>
                            <p>{{ $t('time_mesured_the_last_24_hours') }} : <span class="data-display">22 h 00</span></p>
                            <p>{{ $t('estimated_hourly_cost') }}: <span class="data-display">36 €</span></p>
                        </div> -->
                        <el-row>
                            <el-tooltip class="item" effect="dark" :content="$t('edit')" placement="top">
                                <el-button type="primary" icon="el-icon-edit" @click="editproductionZone" circle></el-button>
                            </el-tooltip>
                            <el-tooltip class="item" effect="dark" :content="$t('duplicate')" placement="top">
                                <el-button v-if="isSuperAdmin"  type="primary" icon="el-icon-document-copy" @click="duplicateproductionZone" circle></el-button>
                            </el-tooltip>
                            <!-- <el-tooltip class="item" effect="dark" :content="$t('details')" placement="top" v-if="isSuperAdmin">
                                <el-button type="primary" icon="el-icon-s-data" @click="getDetailsView" circle></el-button>
                            </el-tooltip> -->
                        </el-row>
                    </el-col>
                    <el-col :span="9">
                        <div class="table-card">
                            <h3>{{ $t('beacon_time') }}</h3>
                            <el-table
                                v-loading="loading"
                                :data="getBeaconCumulTimeByProductionZone"
                                height="250"
                                size="small">
                                <el-table-column
                                    prop="shortId"
                                    :label="'Badge id'">
                                </el-table-column>
                                <el-table-column
                                    :label="$t('duration')">
                                     <template slot-scope="scope">
                                        <span>{{ getHourMinutes(scope.row.time) }}</span> 
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </el-col>
                    <!-- <el-col :span="9">
                        <div class="table-card">
                            <h3>{{ $t('manufacturing_order_in_progress_attached') }}</h3>
                            <el-table
                            :data="manufacturingOrderAssociated"
                            size="small">
                            <el-table-column
                                prop="name"
                                :label="$t('name')">
                            </el-table-column>
                            <el-table-column
                                :label="$t('total_time')">
                                <template slot-scope="scope">
                                    <span style="margin-left: 10px">{{ getElapsedTime(scope.row.start, scope.row.end) }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                :label="$t('status')">
                                <template slot-scope="scope">
                                    <span style="margin-left: 10px">{{ isRunningResult(scope.row) }}</span>
                                </template>
                            </el-table-column>
                            </el-table>
                        </div>
                    </el-col> -->
                    <el-col :span="9">
                        <div style="max-width: 300px; margin: auto;">
                            <vue-apex-charts :options="chartOne.options" :series="chartOne.series" />
                        </div>
                    </el-col>
                </el-row>
            </el-card>
        </div>
        <!-- start Modal for Create OF form -->
        <el-dialog
            width="1200px"
            :visible.sync="dialogFormVisible"
            :modalAppendToBody="false">
            <CreateProductionZone :formStateModal="ofFormType" :itemSelected="productionZone" :key="dialogFormVisible" @closeForm="closeForm"></CreateProductionZone>
            </el-dialog>
        <!-- end Modal for Create OF form -->
    </div>
</template>

<script>
import CreateProductionZone from '../components/production-zone/CreateProductionZone.vue'
import DateTimeManipulation from '../mixins/DateTimeManipulation'
import { chartPie1 } from '../data/chartTemplate'
import VueApexCharts from 'vue-apexcharts';

export default {
    components: {
        CreateProductionZone,
        VueApexCharts
    },
    props: {
        productionZone: {
            type: Object,
        }
    },
    data() {
        return {
            ofFormType: 'edit',
            dialogFormVisible: false,
            chartOne: {},
            isSuperAdmin: false,
            loading: true,
        }
    },
    created() {
        this.chartOne = JSON.parse(JSON.stringify(chartPie1));
        this.chartOne.options.labels = this.manufacturingOrderAssociatedForChart.labels;
        this.chartOne.series = this.manufacturingOrderAssociatedForChart.series;
        this.isSuperAdmin = this.$store.getters.isSuperAdmin;
        this.$store.dispatch('getLogsByProductionZone', this.productionZone.nodeId);
    },
    computed: {
        manufacturingOrderAssociated() {
           return this.$store.getters.manufacturingOrderAssociated(this.productionZone.id);
        },
        manufacturingOrderAssociatedForChart() {
            let dt = this.$store.getters.manufacturingOrderAssociated(this.productionZone.id);
            let series = dt.map( d => d.end - d.start );
            let labels = dt.map( d => d.name );
            return { series, labels};
        },
        getOfElapsedTime() {
            let dt = this.$store.getters.manufacturingOrderAssociated(this.productionZone.id);
            return this.getElapsedTime(dt.start, dt.end);
        },
        getBeaconCumulTimeByProductionZone() {
            return this.$store.getters.getBeaconCumulTimeByProductionZone(this.productionZone.nodeId);
        },
        getBeaconShortId(beaconId) {
            return this.$store.getters.getBeaconShortId(beaconId);
        }
    },
    watch: {
        manufacturingOrderAssociated(nVal) {
            let series = nVal.map( d => d.end - d.start );
            let labels = nVal.map( d => d.name );
            this.chartOne.series = series;
            this.chartOne.options.labels = labels;
        },
        getBeaconCumulTimeByProductionZone(nVal) {
             if(nVal !== undefined) {
                this.loading = false;
            }
        }
    },
    methods: {
        editproductionZone: function() {
            this.ofFormType = 'edit';
            this.dialogFormVisible = true;
        },
        duplicateproductionZone: function() {
            this.ofFormType = 'duplicate';
            this.dialogFormVisible = true;
        },
        getDetailsView: function() {
            this.$router.push({ name: 'production-zone-details', params: { id: this.productionZone.id } })
        },
        setChartTest: function() {
            this.chartOne.series = this.manufacturingOrderAssociatedForChart.series;
            this.chartOne.options.labels = this.manufacturingOrderAssociatedForChart.labels;
        },
        closeForm: function() {
            this.dialogFormVisible = false;
        },
        isRunningResult(manufacturedOrder) {
            let now = new Date().getTime();
            if( now < manufacturedOrder.start ) {
                return 'A venir'
            } else if (now > manufacturedOrder.end) {
                return this.$t('ended')
            } else {
                return this.$t('running')
            }
        },
        getHourMinutes(minutes) {
            const h = Math.floor(minutes / 60);
            const m = minutes % 60;
            return `${h} H ${m < 10 ? '0'+m : m}`;
        }
    },
    mixins: [DateTimeManipulation]
}
</script>

<style scoped>
    h3 {
        color: white;
    }

    .mini-card {
        margin-bottom: 20px;
    }

    .table-card {
        background-color: var(--color1light);
        padding: 10px;
        border-radius: 12px;
    }

    .info-identity {
        margin-bottom: 24px;

    }

    .info-identity > p {
        margin: 5px;
    }

    .data-display {
        font-weight: bold;
    }
</style>